import React from 'react';

const Divider = () => (
  <div style={{ background: 'black', flex: '0 0 2px' }} />
);

export default Divider;
